import React from "react";
import { Reveal } from "./Reveal";

export const PageHero = ({ tag, title, subtitle, image }) => {
  return (
    <section data-testid="page-hero" className="relative flex min-h-[60vh] items-end overflow-hidden pt-24">
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-matte via-black/70 to-black/50" />
        </div>
      )}
      <div className="mx-auto w-full max-w-7xl px-5 pb-16 lg:px-8">
        <Reveal><span className="font-body text-xs uppercase tracking-[0.3em] text-gold">{tag}</span></Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-5 max-w-3xl font-heading text-5xl font-medium leading-[1] tracking-tight text-white lg:text-7xl">{title}</h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={0.2}><p className="mt-6 max-w-2xl font-body text-base leading-relaxed text-white/60">{subtitle}</p></Reveal>
        )}
      </div>
    </section>
  );
};
